import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ContainerModule } from 'ng-labs/container';
import { HeaderBarActionComponent } from './header-bar-action.component';
import { HeaderBarLeftActionsComponent } from './header-bar-left-actions.component';
import { HeaderBarLogoDirective } from './header-bar-logo.directive';
import { HeaderBarRightActionsComponent } from './header-bar-right-actions.component';
import { HeaderBarComponent } from './header-bar.component';

@NgModule({
  imports: [CommonModule, ContainerModule, MatButtonModule, MatIconModule],
  exports: [
    HeaderBarComponent,
    HeaderBarRightActionsComponent,
    HeaderBarActionComponent,
    HeaderBarLogoDirective
  ],
  declarations: [
    HeaderBarComponent,
    HeaderBarLeftActionsComponent,
    HeaderBarRightActionsComponent,
    HeaderBarActionComponent,
    HeaderBarLogoDirective
  ],
  providers: []
})
export class HeaderBarModule {}
